exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"BasePage.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?sourceMap!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48eb86a7","scoped":false,"hasInlineConfig":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/BasePage.vue
// module id = 426
// module chunks = 0